import './App.css';
import { useEffect,useContext} from "react";
//import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HashRouter, Routes, Route } from "react-router-dom";
import routes from "./routes/routes";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { GlobalProvider } from './GlobalContext';
import { AppRefreshContext } from "./AppRefresh";


function App() {
   const { appKey } = useContext(AppRefreshContext);
   useEffect(() => {
    const storedClass = localStorage.getItem('i18nextLng');
    if (storedClass) {
       document.body.setAttribute('data-lang', storedClass); // replaces existing classes
    }
  }, []);
  return (
    <GlobalProvider>
    
    <HashRouter key={appKey}>
      <Routes>
        {routes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} />
        ))}
      </Routes>
    </HashRouter>
  
    </GlobalProvider>
  );
}

export default App;
